module.exports = " <div class=toggle-fieldtype-wrapper> <div class=toggle-container :class=\"{ 'on': isOn }\" @click=toggle> <div class=toggle-slider> <div class=toggle-knob tabindex=0 @keyup.prevent.space.enter=toggle v-el:knob tabindex=0></div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/ToggleFieldtype.vue
// module id = 772
// module chunks = 0